/* eslint-disable no-unused-vars */
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ChevronLeft, Clock, Calendar, User } from "lucide-react";

export const ARTICLES = [
  {
    id: "1",
    title: "Getting Started with Donezo",
    category: "General",
    date: "Oct 20, 2024",
    author: "Support Team",
    content:
      "Donezo is your all-in-one platform for managing care services. To get started, complete your profile verification...",
  },
  {
    id: "2",
    title: "How to post a service request",
    category: "Services",
    date: "Oct 22, 2024",
    author: "Admin",
    content:
      'Navigate to the "Post Service" page from the sidebar. Select the client you are posting for, or create a new one...',
  },
  {
    id: "3",
    title: "Managing your subscription plan",
    category: "Billing",
    date: "Oct 25, 2024",
    author: "Billing Dept",
    content:
      'You can view your current plan in the Subscription Management page. To upgrade, click "Upgrade Plan" and select...',
  },
  {
    id: "4",
    title: "Understanding Caregiver Ratings",
    category: "Guides",
    date: "Oct 28, 2024",
    author: "Quality Assurance",
    content:
      "Ratings are calculated based on client feedback after every completed job. A 5-star rating indicates exceptional service...",
  },
  {
    id: "5",
    title: "Payment Methods and Security",
    category: "Billing",
    date: "Nov 01, 2024",
    author: "Security Team",
    content:
      "We support major credit cards and bank transfers. All transactions are encrypted using industry-standard SSL protocols...",
  },
  {
    id: "6",
    title: "How to cancel a booking",
    category: "Bookings",
    date: "Nov 05, 2024",
    author: "Support Team",
    content:
      'To cancel a booking, go to the Bookings page, find the relevant booking, click the action menu, and select "Cancel". Note that cancellation fees may apply...',
  },
  {
    id: "7",
    title: "Vetting Process for Caregivers",
    category: "Trust & Safety",
    date: "Nov 10, 2024",
    author: "Vetting Team",
    content:
      "Our vetting process includes 5 stages: Application, Document Verification, Medical Testing, Interview, and Final Exam...",
  },
  {
    id: "8",
    title: "Contacting Support",
    category: "Support",
    date: "Nov 12, 2024",
    author: "Customer Service",
    content:
      "You can reach us via the Contact Us page, email us at support@donezo.com, or call our hotline...",
  },
  {
    id: "9",
    title: "Updating Profile Information",
    category: "Account",
    date: "Nov 15, 2024",
    author: "Admin",
    content:
      'Go to your Profile page and click the "Edit" button. You can update your bio, contact info, and skills...',
  },
  {
    id: "10",
    title: "Resetting your password",
    category: "Account",
    date: "Nov 18, 2024",
    author: "Security Team",
    content:
      'If you forgot your password, click "Forgot Password" on the login screen. If logged in, go to Settings > Security to change it...',
  },
];

const Article = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const article = ARTICLES.find((a) => a.id === id);

  if (!article)
    return (
      <div className="p-8 text-center flex flex-col items-center justify-center h-[50vh] bg-background dark:bg-dark-background">
        <h2 className="text-2xl font-bold text-text dark:text-dark-text mb-2">
          Article Not Found
        </h2>
        <button
          onClick={() => navigate("/help")}
          className="text-primary hover:underline"
        >
          Back to Help
        </button>
      </div>
    );

  return (
    <div className="animate-in fade-in slide-in-from-right-4 duration-500 max-w-4xl mx-auto pb-12 bg-background dark:bg-dark-background min-h-screen p-4">
      <button
        onClick={() => navigate("/help")}
        className="flex items-center gap-2 text-gray-500 hover:text-text dark:text-dark-muted dark:hover:text-dark-text mb-6 transition-colors font-medium"
      >
        <ChevronLeft size={20} /> Back to Help Center
      </button>

      <div className="bg-card dark:bg-dark-surface rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100 dark:border-dark-border">
        <span className="px-3 py-1 bg-primary/10 dark:bg-primary/20 text-primary dark:text-primary rounded-full text-xs font-bold uppercase tracking-wide mb-6 inline-block">
          {article.category}
        </span>
        <h1 className="text-3xl md:text-4xl font-extrabold text-text dark:text-dark-text mb-6 leading-tight">
          {article.title}
        </h1>

        <div className="flex items-center gap-6 text-sm text-gray-500 dark:text-dark-muted mb-8 border-b border-gray-100 dark:border-dark-border pb-8">
          <div className="flex items-center gap-2">
            <User size={16} /> <span>{article.author}</span>
          </div>
          <div className="flex items-center gap-2">
            <Calendar size={16} /> <span>{article.date}</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock size={16} /> <span>5 min read</span>
          </div>
        </div>

        <div className="prose dark:prose-invert max-w-none text-gray-600 dark:text-dark-muted leading-loose">
          <p>{article.content}</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <h3 className="text-xl font-bold text-text dark:text-dark-text mt-8 mb-4">
            Detailed Instructions
          </h3>
          <p>
            Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
            cupidatat non proident, sunt in culpa qui officia deserunt mollit
            anim id est laborum.
          </p>
          <p className="mt-4">
            If you need further assistance, please do not hesitate to contact
            our support team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Article;
